import React, { type ChangeEvent, type FC } from 'react'
import { TextField } from '@mui/material'
import { AddButtonContainer } from '../filters/Filters.style'
import Add from '@mui/icons-material/Add'
import { useTranslation } from 'react-i18next'

interface LabelsInputProps {
  labelValue: string
  onLabelValueChange: (value: string) => void
  onInsertNewLabel: (value: string) => void
}

/**
 * Labels input control component.
 */
export const LabelsInput: FC<LabelsInputProps> = ({
  labelValue,
  onLabelValueChange,
  onInsertNewLabel
}) => {
  const { t } = useTranslation()

  const onValueChange = (e: ChangeEvent<HTMLInputElement>): void => {
    onLabelValueChange(e.target.value)
  }

  const onInsert = (e: React.MouseEvent<HTMLInputElement>): void => {
    e.preventDefault()
    onInsertNewLabel(labelValue)
  }

  const tooltip = t('labels.addLabelTooltip')
  return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <TextField variant="outlined" size="small" onChange={onValueChange} placeholder={tooltip}
                       value={labelValue} style={{ width: 'max-content', flex: 0.4, marginRight: '14px' }}
                       inputProps={{ 'data-testid': 'label-input' }}/>
            <AddButtonContainer aria-controls='add-labels' aria-haspopup={true} onClick={onInsert}
                                data-testid="label-submit">
                <Add style={{ color: '#ffffff', alignSelf: 'center', margin: 'auto', cursor: 'pointer' }}/>
            </AddButtonContainer>
        </div>
  )
}
